import { render } from "./ForgotPasswordView.vue?vue&type=template&id=caa51aa4&scoped=true&ts=true"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=caa51aa4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa51aa4"]])

export default __exports__